import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import Beatloader from '../../../../Common/BeatLoader'
import ResponsivePagination from '../../../../Common/Pagination'
import { getStudentStudyMaterialPptListData } from '../../../../Redux/action/StudentAction'

const host = process.env.REACT_APP_API_SERVER

const StudentPptNotes = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getStudentStudyMaterialPptListData())
    }, []);

    const {
        loadingStudentStudyMaterialPptListApi,
        StudentStudyMaterialPptListApiData,
    } = useSelector(state => state?.StudentReducer);

    const handlePptClick = (materialFile) => {

        if (!materialFile) return;

        const pathParts = materialFile.split('/');

        const fileName = pathParts.pop();

        const encodedFileName = encodeURIComponent(fileName);

        const encodedPath =
            `${host}${pathParts.join('/')}/${encodedFileName}`;

        window.open(encodedPath, "_blank", "noopener,noreferrer");
    };

    // pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const dataPerPage = 10;

    useEffect(() => {

        if (!StudentStudyMaterialPptListApiData) return;

        const start = (currentPage - 1) * dataPerPage;

        const end = start + dataPerPage;

        setCurrentData(
            StudentStudyMaterialPptListApiData.slice(start, end)
        );

        setPageCount(
            Math.ceil(
                StudentStudyMaterialPptListApiData.length / dataPerPage
            )
        );

    }, [currentPage, StudentStudyMaterialPptListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    return (
        <div className='pagination-component'>

            <section className="after-header">

                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item ps-5">

                            <button
                                onClick={() => window.history.back()}
                                style={{
                                    border: "none",
                                    background: "none"
                                }}
                            >
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </button>

                            &nbsp;&nbsp;PPT Notes

                        </li>
                    </ol>
                </nav>

                <div className="main-container-sec">

                    <div className="row mx-0">

                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>

                        <div className="col-lg-9">

                            <main className="px-3 py-4">

                                <div className="my-student-sec">

                                    {loadingStudentStudyMaterialPptListApi ?

                                        <Beatloader />

                                        :

                                        <div className="row">

                                            {StudentStudyMaterialPptListApiData?.length > 0 ?

                                                currentData?.map((data) => (

                                                    <div
                                                        className="col-lg-6 mt-3 col-md-6"
                                                        key={data?.id}
                                                        onClick={() =>
                                                            handlePptClick(
                                                                data?.material_file
                                                            )
                                                        }
                                                    >

                                                        <div
                                                            className="card input-card-form notescard"
                                                            style={{
                                                                backgroundColor: "aliceblue",
                                                                cursor: "pointer"
                                                            }}
                                                        >

                                                            <div className="card-body">

                                                                <div className="row gap-0">

                                                                    <div className="col-lg-4 justify-content-center d-flex">

                                                                        <img
                                                                            src="/assets/img/user/ppt.png"
                                                                            className="img-fluid"
                                                                            style={{
                                                                                height: 85,
                                                                                width: "auto",
                                                                                borderRadius: 15
                                                                            }}
                                                                        />

                                                                    </div>

                                                                    <div className="col-lg-8 m-0 p-0 d-flex flex-column text-start justify-content-center">

                                                                        <h5 className="mb-0 text-dark">
                                                                            {data?.study_material?.material_name}
                                                                        </h5>

                                                                        <p className="mb-0">
                                                                            {new Date(data?.createdAt).toDateString()}
                                                                        </p>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>

                                                ))

                                                :

                                                <div className='no-data-img text-center'>

                                                    <img
                                                        width={100}
                                                        src="/assets/img/user/no-data.png"
                                                        alt=""
                                                    />

                                                </div>

                                            }

                                        </div>

                                    }

                                    {pageCount > 1 && (
                                        <ResponsivePagination
                                            pageCount={pageCount}
                                            currentPage={currentPage}
                                            handlePageClick={handlePageClick}
                                        />
                                    )}

                                </div>

                            </main>

                        </div>

                    </div>

                </div>

            </section>

        </div>
    )
}

export default StudentPptNotes